import { load } from './_load.js';

export let comment = {
	all: [],
	filtered: [],
	list: [],//現在のランクのコメント + 静的コメント
	currentComments: [],
	currentTime: 0,
	jsonPath: "/jlc/listenplus/app/comment.json",
	init: function(time){
		comment.currentTime = time/60;
		console.log(time)
		load.getJson(this.jsonPath, {}).then( (res) => {
			comment.all = res.comment;
			let before = 0;
			let arry = [];
			for(let i = 0; i < comment.all.length; i++){
				let c = comment.all[i];
				//console.log(c.range, before);
				if(c.range != before){
					comment.filtered.push(arry);
					arry = [];
					arry.push(c);
				}else{
					arry.push(c);
				}
				if(i === comment.all.length - 1){
					comment.filtered.push(arry);
				}
				before = c.range;
			}
			//comment.staticComment = res.staticComment;
			//console.log("コメント一覧: ", comment.filtered);
			comment.getCurrent();
			let myComment = comment.getRandom();
			document.querySelector(".chart_currentmonth .img_jme img").setAttribute("src", myComment.top_image_url);
			document.querySelector(".chart_currentmonth .block_comment img").setAttribute("src", myComment.comment_image);
		});
	},
	getCurrent: function(){
		for(let i = 0; i < comment.filtered.length; i++){
			let startRange = comment.filtered[i][0].range;
			//console.log(comment.filtered, startRange, comment.currentTime)
			if(i >= comment.filtered.length - 1){
				if( comment.currentTime >= startRange ){
					comment.currentComments = comment.filtered[i];
				}
			}else{
				if( comment.currentTime >= startRange && comment.currentTime < comment.filtered[i+1][0].range ){
					comment.currentComments = comment.filtered[i];
				}
			}
		}
		comment.list = comment.currentComments;
	},
	getRandom: function(){
		let randomIndex = Math.floor( Math.random()*comment.list.length );
		//console.log(randomIndex, comment.list);
		return comment.list[randomIndex];
	}
}